import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const DrawIcon = withSvgIcon(
    <g>
        <path d="M469.2 93.3l-65.3-64.5c-4.3-4.2-9.9-6.3-15.5-6.3s-11.2 2.1-15.5 6.3l-22.4 22.1-11.7 11.6L323 78.1l-11.7 11.6L68.2 329.6l-13.9 13.7-.2.2-.3.3.1.1-25.5 115.4-4 18.2 17.8-5.4 107.4-33 .1.1.2-.2 13.1-13 245-241.9 11.7-11.6 15.8-15.5 11.7-11.6 21.9-21.6c8.6-8.4 8.6-22.1.1-30.5zm-381 347.8l-33.3-26.4 12.7-57.3.2.2 69.1 68.7-48.7 14.8zm61.6-21.6l-76.1-75.6L321.3 99.4l76.8 74.9-248.3 245.2zm260-256.8L333 87.8l15.8-15.5 76.8 74.9-15.8 15.5zm49.6-48.9l-22 21.8-76.8-74.9 22.2-21.9c1.5-1.5 3.5-2.3 5.6-2.3 2.2 0 4.2.8 5.6 2.3l65.3 64.5c1.9 1.9 2.2 4.1 2.2 5.3.1 1.1-.2 3.3-2.1 5.2z" />
    </g>,
    "-10 0 500 500"
);
